import { BrandName } from '@/types';
import { Typography } from 'antd';
import { useEffect, useState } from 'react';
import CustomTable from '../table';

const { Text } = Typography;

interface Props {
  data: BrandName[];
  columns: any[];
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  limit: number;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  total: number;
  downloadData?: (record: any) => void;
}

export function BrandNamesTable({
  data,
  columns,
  page,
  setPage,
  limit,
  setLimit,
  total,
  downloadData,
}: Props) {
  const [filteredData, setFilteredData] = useState<BrandName[]>([]);

  useEffect(() => {
    if (!data) return;
    const formattedData = data?.map((brandName) => ({
      ...brandName,
      key: brandName?._id,
    }));
    setFilteredData(formattedData);
  }, [data]);

  return (
    <>
      <div className="tables-info">
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          {total} Total Brand Names
        </Text>
        <span className="tables-divider" />
        <Text style={{ color: '#9FA1AD', fontWeight: 500 }}>
          Updated 20 min ago
        </Text>
      </div>

      <CustomTable
        data={data}
        columns={columns}
        filteredData={filteredData}
        setFilteredData={setFilteredData}
        isDetailed={false}
        isBrandNameStatus
        label="Company Brands"
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
        downloadData={downloadData}
      />
    </>
  );
}
